import { gql, TypedDocumentNode } from "@apollo/client";
import { ProgramStatus } from "@/types";
import type { CreateTestPersonPatStatus } from "@/pages/people/_components/createTestPerson/types";

export type CreateTestPersonInput = {
  programType?: string;
  classificationId?: string;
  status?: ProgramStatus;
  sectionId?: string;
  completedPgmLevelCodes?: string[];
  includeApprovedBackgroundCheck?: boolean;
  droppedPgmStudent?: boolean;
  graduatedPgmStudent?: boolean;
  includePreQualifierBand?: boolean;
  includeQualifierEligibleBand?: boolean;
  patStatus?: CreateTestPersonPatStatus;
  includeAssociateL1Progress?: boolean;
  includeOpenDues?: boolean;
  ineligiblyEmployed?: boolean;
  pendingAffiliateRegistration?: boolean;
  expiredPat?: boolean;
};

export type CreateTestPersonResponse = {
  createTestPerson: {
    success: boolean;
    message: string;
    code: number;
    person: { pgaId: string; firstName: string; lastName: string; email: string } | null;
  };
};

export const CREATE_TEST_PERSON_OPTIONS_QUERY: TypedDocumentNode<{
  classifications: {
    nodes: { id: string; name: string; programType: { id: string; name: string } }[];
  };
  crmSections: { nodes: { id: string; name: string }[] };
}> = gql`
  query CreateTestPersonOptions {
    classifications {
      nodes {
        id
        name
        programType {
          id
          name
        }
      }
    }
    crmSections {
      nodes {
        id
        name
      }
    }
  }
`;

export const CREATE_TEST_PERSON_MUTATION: TypedDocumentNode<
  CreateTestPersonResponse,
  { input: CreateTestPersonInput }
> = gql`
  mutation CreateTestPerson($input: BackofficeCreateTestPersonInput!) {
    createTestPerson(input: $input) {
      success
      message
      code
      person {
        pgaId
        firstName
        lastName
        email
      }
    }
  }
`;
